// extracted by mini-css-extract-plugin
module.exports = {"full":"styles_full__2JWy_","input":"styles_input__SKRM4","label":"styles_label__3u4Ux","value":"styles_value__14YXE","inputBox":"styles_inputBox__1hBoD"};